import React, { ComponentProps, ReactNode } from 'react';
import {
  TextArea,
  FormInput,
  Label,
  IFormInputProps,
  TextAreaProps,
} from '@grubhubprod/gh-cookbook-react';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

interface CookbookTextareaWrapperBaseProps {
  name: string;
  control: Control;
  rules?: RegisterOptions;
  error?: IFormInputProps['error'];
  label: ReactNode;
}

export type CookbookTextareaWrapperProps = CookbookTextareaWrapperBaseProps &
  TextAreaProps;

export const CookbookTextareaWrapper: React.FC<CookbookTextareaWrapperProps> =
  ({
    name,
    control,
    rules,
    error,
    label,
    defaultValue = '',
    ...cookbookTextareaProps
  }) => {
    return (
      <Controller
        name={name}
        rules={rules}
        control={control}
        defaultValue={defaultValue}
        render={({ ...field }): JSX.Element => (
          <FormInput
            error={error}
            inputSize={cookbookTextareaProps.inputSize}
            blockWidth={cookbookTextareaProps.blockWidth}
          >
            <Label htmlFor={cookbookTextareaProps.id}>{label}</Label>
            <TextArea
              {...field}
              {...(cookbookTextareaProps as ComponentProps<typeof TextArea>)}
            />
          </FormInput>
        )}
      />
    );
  };
